// A simple registry to keep track of tab bubble refs
const tabBubbleRefs: {[roomCode: string]: React.RefObject<HTMLElement>} = {};

export const registerTabBubbleRef = (roomCode: string, ref: React.RefObject<HTMLElement>) => {
  tabBubbleRefs[roomCode] = ref;
};

export const deregisterTabBubbleRef = (roomCode: string) => {
  delete tabBubbleRefs[roomCode];
};

export const getTabBubbleRefForRoom = (roomCode: string) => {
  return tabBubbleRefs[roomCode] || null;
};
